import { useRoute } from 'react-router5';
import { useEffect } from 'react';

export function useModalName(): string {
  const { route } = useRoute();
  const modal = route?.params?.w ?? '';
  useEffect(() => {
    document.body.classList.toggle('modal', !!modal);
  }, [modal]);
  return modal;
}
